import { OperatorSymbolNodeModel } from "@/models/nodes/OperatorSymbolNodeModel";

import type { FunctionNodeModel } from "@/models/nodes/FunctionNodeModel";

export function shouldOmitParentheses(node: FunctionNodeModel): boolean {
  if (node.parenthesesVisibility === "auto") {
    const [nextSibling] = node.nextSiblings;
    const nextSiblingAllowsOmission = !nextSibling || nextSibling.is(OperatorSymbolNodeModel);

    return node.omitParentheses && nextSiblingAllowsOmission;
  }

  return node.omitParentheses;
}
